<template lang="html">
  <div class="row no-gutters">
    <div v-for="floorplan in floorplanList"
    :key="floorplan.id"
    class="floorplan-grid-tile-item col-xl-6 col-12 p-1">
      <floorplan-grid-tile
      :floorplan="floorplan"
      :selectLabel="'SELECT'"
      @click.native="selectFloorplan(floorplan.id)"
      class="grid-tile"
      />
    </div>
  </div>
</template>

<script>
import FloorplanGridTileComponent from '@/components/Floorplan/FloorplanGridTile';

export default {
  props: {
    floorplanList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    selectFloorplan(floorplanId) {
      this.$emit('selected', floorplanId);
    }
  },
  components: {
    'floorplan-grid-tile': FloorplanGridTileComponent,
  },
};
</script>

<style lang="scss" scoped>
.floorplan-grid-tile-item {
  @media screen and (min-width: $breakpoint-xl) {
    &:nth-child(even) {
      padding-right: 0 !important;
    }
    &:nth-child(odd) {
      padding-left: 0 !important;
    }
  }
}
.grid-tile {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanCompare/FloorplanCompareGrid.vue